export const defaultSEO = {
    mrp: {
        brandName: 'MR PORTER'
    },
    ton: {
        brandName: 'THE OUTNET'
    },
    theoutnet: {
        brandName: 'THE OUTNET'
    },
    nap: {
        brandName: 'NET-A-PORTER'
    }
};
